import * as React from "react";
import {Paragraph} from "../../elements/Paragraph/Paragraph";
import './Marquee.scss';

export const Marquee = ({ marquee_blocks }) => {
    return (
        <div className="marquee-banner">
            <div className="marquee-track">
                {marquee_blocks.map((marquee, marquee_id) => (
                    <div className="marquee-content" key={marquee_id}>
                        { marquee.settings.icon && (<img src={ marquee.settings.icon } alt="Icon" className="marquee-icon h-5" />) }
                        <Paragraph text={marquee.settings.text} />
                    </div>
                ))}
                {marquee_blocks.map((marquee, marquee_id) => (
                    <div className="marquee-content" key={marquee_id}>
                        { marquee.settings.icon && (<img src={ marquee.settings.icon } alt="Icon" className="marquee-icon h-5" />) }
                        <Paragraph text={marquee.settings.text} />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Marquee;